import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export async function getDuplicateSubmissionsReportsByType(
  startrow,
  maxrows,
  type,
  filter,
  selectedJournalIds
) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      maxrows: maxrows,
      startrow: startrow,
      filter: filter, // 'triggers' -> 'matching' | 'matched' | 'own_journals' | with_other_publisher
      type: type, // 'wo_status' | 'all' | 'metadata' | 'fts_only'
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.DUPLICATE_SUBMISSIONS_REPORTS_BY_TYPE,
    method: "get",
  });
}

export async function getAllDuplicateSubmissions(
    startrow,
    maxrows,
    filter,
    selectedJournalIds
) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      maxrows: maxrows,
      startrow: startrow,
      filter: filter,
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.ALL_DUPLICATE_SUBMISSIONS,
    method: "get",
  });
}

export async function getDuplicateSubmissionsCount(selectedJournalIds) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.DUPLICATE_SUBMISSIONS_COUNT,
    method: "get",
  });
}

export async function getDuplicateSubmissionById(id) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      type: "duplicateSubmissions",
    },
    path: API_PATHS.DUPLICATE_SUBMISSION_BY_ID(id),
    method: "get",
  });
}

export async function updateTriggerOrMatchStatus(id, persistentId, submissionStatus, additionalParams = {}) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    path: API_PATHS.UPDATE_TRIGGER_OR_MATCH_STATUS(id),
    body: { persistentId, submissionStatus, ...additionalParams },
    method: "patch",
  });
}

export async function getAllAmbientScreeningSubmissions(
    startrow,
    maxrows,
    filter,
    type,
    selectedJournalIds
) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      maxrows,
      startrow,
      filter,
      type,
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.ALL_AMBIENT_SCREENING_SUBMISSIONS,
    method: "get",
  });
}

export async function getAmbientScreeningSubmissionById(id) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      type: "ambientScreening",
    },
    path: API_PATHS.AMBIENT_SCREENING_SUBMISSION_BY_ID(id),
    method: "get",
  });
}

export async function updateAmbientScreeningSubmissionStatus(id, submissionStatus, additionalParams = {}) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    path: API_PATHS.UPDATE_AMBIENT_SCREENING_SUBMISSION_STATUS(id),
    body: { submissionStatus, ...additionalParams },
    method: "patch",
  });
}
